<template>
	<div id="informacion-personal-page">
		<div class="info-personal-header">
			<div class="breadcrumb">
				<router-link :to="{ name: 'home' }" class="breadcrumb-item">Inicio</router-link>
				<div class="breadcrumb-item">&#8594;</div>
				<div class="breadcrumb-item">Cuenta</div>
				<div class="breadcrumb-item">&#8594;</div>
				<div class="breadcrumb-item">Información personal</div>
			</div>
			<h1>Información personal</h1>
		</div>
		<div class="info-personal-content" v-if="userData">
			<div class="info-personal-item">
				<div class="item-top">
					<span class="label">Email</span>
				</div>
				<div class="item-main">
					<span class="value">{{ userData.UsuarioPersonaEmail }}</span>
				</div>
			</div>
			<div class="info-personal-item">
				<div class="item-top">
					<span class="label">Perfil</span>
					<div class="item-right" @click="editarPerfil()" v-if="!editablePerfil">
						Editar
					</div>
					<div class="item-right" @click="editablePerfil = !editablePerfil" v-else>Cancelar</div>
				</div>
				<div class="item-main">
					<span class="value" v-if="!editablePerfil">{{ userData.UsuarioPersonaNombre }} {{ userData.UsuarioPersonaApellido }}</span>
					<div class="editable-group" v-if="editablePerfil">
						<div class="item-main-row">
							<div class="input-group">
								<label for="">Nombre</label>
								<input type="text" v-model="nombre">
							</div>
							<div class="input-group">
								<label for="">Apellido</label>
								<input type="text" v-model="apellido">
							</div>
						</div>
						<button @click.prevent="guardarPerfil()">Confirmar</button>
					</div>
				</div>
			</div>
			<div class="info-personal-item">
				<div class="item-top">
					<span class="label">Ubicación</span>
					<div class="item-right" @click="editarUbi()" v-if="!editableUbi">
						Editar
					</div>
					<div class="item-right" @click="editableUbi = !editableUbi" v-else>Cancelar</div>
				</div>
				<div class="item-main">
					<span class="value" v-if="!editableUbi">{{ userData.PaisNombre }}</span>
					<div class="editable-group" v-if="editableUbi">
						<div class="item-main-row">
							<div class="input-group">
								<label for="">Pais</label>
								<v-select class="top-right-value" :options="paises" v-model="pais" :clearable="false">
									<div slot="no-options" style="font-size: 12px;">No se encontraron resultados.</div>
								</v-select>
							</div>
						</div>
						<button @click.prevent="guardarUbi()">Confirmar</button>
					</div>
				</div>
			</div>
			<div class="info-personal-item">
				<div class="item-top">
					<span class="label">Teléfono</span>
					<div class="item-right" @click="editarTel()" v-if="!editableTel">
						Editar
					</div>
					<div class="item-right" @click="editableTel = !editableTel" v-else>Cancelar</div>
				</div>
				<div class="item-main">
					<span class="value" v-if="!editableTel">{{ userData.UsuarioPersonaTelefonoPrefijo }} {{ userData.UsuarioPersonaTelefono }}</span>
					<div class="editable-group" v-if="editableTel">
						<div class="item-main-row">
							<div class="input-group">
								<vue-phone-number-input class="form__input" name="phone" id="phone" v-model="phone" :default-country-code="country" :preferred-countries="['UY', 'AR']" @update="phoneUpdated">
									<i class="bx bx-chevron-down" style="font-size: 20px;" slot="arrow"></i>
								</vue-phone-number-input>
							</div>
						</div>
						<button @click.prevent="guardarTel()">Confirmar</button>
					</div>
				</div>
			</div>
			<div class="info-personal-item">
				<div class="item-top">
					<span class="label">Documento</span>
					<div class="item-right" @click="editarDoc()" v-if="!editableDoc">
						Editar
					</div>
					<div class="item-right" @click="editableDoc = !editableDoc" v-else>Cancelar</div>
				</div>
				<div class="item-main">
					<span class="value" v-if="!editableDoc">{{ userData.UsuarioPersonaDocumentoTipoAbreviacion }} {{ userData.UsuarioPersonaDocumento }}</span>
					<div class="editable-group" v-if="editableDoc">
						<div class="item-main-row">
							<div class="input-group">
								<label for="documentType">Tipo de documento</label>
								<v-select :options="documentTypes" v-model="documentType" :clearable="false">
									<div slot="no-options" style="font-size: 12px;">No se encontraron resultados.</div>
								</v-select>
							</div>
							<div class="input-group">
								<label for="documentType">Documento</label>
								<input type="text" v-model="document" placeholder="Sin puntos ni guiones">
							</div>
						</div>
						<button @click.prevent="guardarDoc()">Confirmar</button>
					</div>
				</div>
			</div>
			<!-- <div class="info-personal-item">
				<div class="item-top">
					<span class="label">Fecha de nacimiento</span>
					<div class="item-right" @click="editarFch()" v-if="!editableFch">
						Editar
					</div>
					<div class="item-right" @click="editableFch = !editableFch" v-else>Cancelar</div>
				</div>
				<div class="item-main">
					<span class="value" v-if="!editableFch">{{ userData.UsuarioPersonaFchNacimiento }}</span>
					<div class="editable-group" v-if="editableFch">
						<div class="item-main-row">
							<div class="input-group">
								<date-picker :lang="lang" :format="'DD/MM/YYYY'" v-model="fecha" placeholder="Fecha de nacimiento">
									<template v-slot:header="{ emit }">
										<button class="mx-btn mx-btn-text" @click="emit(ayer())">Ayer</button>
										<button class="mx-btn mx-btn-text" @click="emit(new Date())">Hoy</button>
										<button class="mx-btn mx-btn-text" @click="emit(manana())">Mañana</button>
									</template>
								</date-picker>
							</div>
						</div>
						<button @click.prevent="guardarFch()">Confirmar</button>
					</div>
				</div>
			</div>
			<div class="info-personal-item">
				<div class="item-top">
					<span class="label">Sexo</span>
					<div class="item-right" @click="editarSexo()" v-if="!editableSexo">
						Editar
					</div>
					<div class="item-right" @click="editableSexo = !editableSexo" v-else>Cancelar</div>
				</div>
				<div class="item-main">
					<span class="value" v-if="!editableSexo">{{ userData.UsuarioPersonaSexoTxt }}</span>
					<div class="editable-group" v-if="editableSexo">
						<div class="item-main-row">
							<div class="input-group">
								<v-select :options="sexos" v-model="personaSexo" :clearable="false" v-if="editableSexo">
									<div slot="no-options" style="font-size: 12px;">No se encontraron resultados.</div>
								</v-select>
							</div>
						</div>
						<button @click.prevent="guardarSexo()">Confirmar</button>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { createNamespacedHelpers } from 'vuex';
	const { mapState } = createNamespacedHelpers('AuthModule');
	import VuePhoneNumberInput from 'vue-phone-number-input';
	import "vue-phone-number-input/dist/vue-phone-number-input.css";
	/* import DatePicker from 'vue2-datepicker'; */

	export default {
		data(){
			return {
				editablePerfil: false,
				editableUbi: false,
				editableTel: false,
				editableDoc: false,
				editableFch: false,
				editableSexo: false,

				userData: null,
			
				nombre: "",
				apellido: "",

				country: null,
				city: {
					label: "",
					paiscode: "",
					ciudadcode: 0
				},
				ciudades: [],

				pais: {
					label: "",
					paiscode: ""
				},
				paises: [],
				

				phone: "",
				phonePrefix: "",
				
				documentType: {
					label: "",
					code: 0,
				},
				document: "",
				documentTypes: [],

				fecha: null,

				sexos: [],
				personaSexo: {
					label: "",
					code: "",
				},

				lang: {
					formatLocale: {
						months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'],
						monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'],
						weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
						weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
						weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
					}
				}
			};

		},
		components: {
			'vue-phone-number-input': VuePhoneNumberInput,
			/* DatePicker, */
		},
		computed: {
			...mapState({
				user: state => state.user	
			}),
		},
		metaInfo: {
			title: 'Información personal',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		async mounted(){
			await this.getUserData();
			await this.getPaises()
			await this.getCiudades();
			await this.getDocumentTypes();
			await this.getSexos();
		},
		methods: {
			async getUserData(){
				try {
					let response = await axios.post('/WSUsuario', {
						UsuarioId: this.user.UsuarioId,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 0){
						this.userData = response.data.SDTUsuarioPersonaDatos
						this.nombre = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaNombre
						this.apellido = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaApellido
						this.city.label = response.data.SDTUsuarioPersonaDatos.CiudadNombre + ', ' + response.data.SDTUsuarioPersonaDatos.PaisId
						this.city.paiscode = response.data.SDTUsuarioPersonaDatos.PaisId
						this.city.ciudadcode = response.data.SDTUsuarioPersonaDatos.CiudadId
						this.pais.label = response.data.SDTUsuarioPersonaDatos.PaisNombre
						this.pais.paiscode = response.data.SDTUsuarioPersonaDatos.PaisId
						this.country = response.data.SDTUsuarioPersonaDatos.PrefijoPais
						this.phone = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaTelefono
						this.documentType.label = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaDocumentoTipoNombre
						this.documentType.code = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaDocumentoTipoId
						this.document = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaDocumento
						this.personaSexo.label = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaSexoTxt
						this.personaSexo.code = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaSexo
						this.fecha = response.data.SDTUsuarioPersonaDatos.UsuarioPersonaFchNacimiento
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				} 
			},

			async getPaises() {
				try {
					let response = await axios.post(
						'/WSPaises',
						{}
					);

					if (response.data.ErrorCod === 0) {
						response.data.SDTPaises.map((p) => {
							let pais = {
								label: p.PaisNombre,
								paiscode: p.PaisId,
							};
							this.paises.push(pais);
						});
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				}
			},

			async getCiudades() {
				try {
					let response = await axios.post(
						'/WSCiudades',
						{}
					);

					if (response.data.ErrorCod === 0) {
						response.data.SDTCiudades.map((p) => {
							let ciudad = {
								label: p.CiudadNombre + ', ' + p.PaisId,
								paiscode: p.PaisId,
								ciudadcode: p.CiudadId,
							};
							this.ciudades.push(ciudad);
						});
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				}
			},

			async getDocumentTypes() {
				this.documentTypes = [];

				try {
					let response = await axios.post(
						'/WSDocumentoTipos',
						{}
					);

					if (response.data.ErrorCod === 0) {
						response.data.SDTDocumentoTipos.map((d) => {
							let docType = {
								label: d.DocumentoTipoNombre,
								code: d.DocumentoTipoId,
							};
							this.documentTypes.push(docType);
						});
					}
				} catch (error) {
					console.log("No se encontraron tipos de documento");
				}
			},

			ayer(){
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24);
				return date;
			},

			manana(){
				const today = new Date()
				const tomorrow = new Date(today)
				tomorrow.setDate(tomorrow.getDate() + 1)
				return tomorrow;
			},

			async getSexos() {
				try {
					let response = await axios.post(
						'/WSSexo',
						{}
					);

					if (response.data.ErrorCod === 0) {
						response.data.SDTPersonaSexos.map((s) => {
							let sexo = {
								label: s.PersonaSexoTxt,
								code: s.PersonaSexo,
							};
							this.sexos.push(sexo);
						});
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				}
			},

			editarPerfil(){
				this.editablePerfil = true
			},

			async guardarPerfil(){
				this.editablePerfil = false

				try {
					let response = await axios.post('/WSEditarPerfil', {
						UsuarioId: this.user.UsuarioId,
						UsuarioPersonaNombre: this.nombre,
						UsuarioPersonaApellido: this.apellido,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if (response.data.ErrorCod === 0) {
						await this.getUserData()
						this.$store.dispatch('showSuccess', 'Nombre modificado con éxito')
					}else{
						this.$store.dispatch('showError', response.data.ErrorDsc)
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
				}
			},

			editarUbi(){
				this.editableUbi = true
			},
			async guardarUbi(){
				this.editableUbi = false

				try {
					let response = await axios.post('/WSEditarUbicacion', {
						UsuarioId: this.user.UsuarioId,
						PaisId: this.pais.paiscode,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if (response.data.ErrorCod === 0) {
						this.getUserData()
						this.$store.dispatch('showSuccess', 'Ubicación modificada con éxito')
					}else{
						this.$store.dispatch('showError', response.data.ErrorDsc)
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
				}
			},

			editarTel(){
				this.editableTel = true
			},
			async phoneUpdated(payload) {
				if (payload.nationalNumber) {
					let phone = payload.nationalNumber;
					let phonePrefix = payload.countryCallingCode;

					this.phone = phone.trim();
					this.phonePrefix = phonePrefix;
				} else {
					this.phone = null;
					this.phonePrefix = null;
				}
			},
			async guardarTel(){
				this.editableTel = false

				try {
					let response = await axios.post('/WSEditarTelefono', {
						UsuarioId: this.user.UsuarioId,
						PaisTelefonoPrefijo: this.phonePrefix,
						PersonaTelefono: this.phone,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if (response.data.ErrorCod === 0) {
						this.getUserData()
						this.$store.dispatch('showSuccess', 'Teléfono modificado con éxito')
					}else{
						this.$store.dispatch('showError', response.data.ErrorDsc)
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
				} 
			},

			editarDoc(){
				this.editableDoc = true
			},
			async guardarDoc(){
				

				try {
					let response = await axios.post('/WSEditarDocumento', {
						UsuarioId: this.user.UsuarioId,
						DocumentoTipoId: this.documentType.code,
						PersonaDocumento: this.document,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if (response.data.ErrorCod === 0) {
						this.editableDoc = false
						this.getUserData()
						this.$store.dispatch('showSuccess', 'Documento modificado con éxito')
					}else{
						this.$store.dispatch('showError', response.data.ErrorDsc)
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
				}  
			},

			editarFch(){
				this.editableFch = true
			},
			async guardarFch(){
				this.editableFch = false
			
				try {
					let response = await axios.post('/WSEditarFchNacimiento', {
						UsuarioId: this.user.UsuarioId,
						Fecha: this.fecha,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if (response.data.ErrorCod === 0) {
						this.getUserData()
						this.$store.dispatch('showSuccess', 'Fecha de nacimiento modificada con éxito')
					}else{
						this.$store.dispatch('showError', response.data.ErrorDsc)
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
				}  
			},

			editarSexo(){
				this.editableSexo = true
			},
			async guardarSexo(){
				this.editableSexo = false

				try {
					let response = await axios.post('/WSEditarSexo', {
						UsuarioId: this.user.UsuarioId,
						PersonaSexo: this.personaSexo.code,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if (response.data.ErrorCod === 0) {
						this.getUserData()
						this.$store.dispatch('showSuccess', 'Sexo modificado con éxito')
					}else{
						this.$store.dispatch('showError', response.data.ErrorDsc)
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
				}  
			}
		}
	}
</script>

<style lang="scss">
	@import '~vue2-datepicker/scss/index.scss';

	.mx-datepicker{
		width: 100%;
	}

	.mx-datepicker-main, .mx-btn{
		font-family: 'Barlow', sans-serif;
	}

	.mx-datepicker-main{
		border: 1px solid #ddd;
		border-radius: 5px;
		box-shadow: 0 0 10px 0 rgb(183 192 206 / 20%);
	}

	.mx-btn:hover{
		border-color: #FF93AD;
		color: #FF93AD;
	}

	.mx-calendar-content .cell.active{
		background-color: #FF93AD;
	}

	.mx-input{
		border: 1px solid #ddd;
		outline: none;
		font-family: 'Barlow', sans-serif;
		font-size: 13px;
		font-weight: bold;
		// box-shadow: 0 0 10px 0 rgb(183 192 206 / 20%);
		box-shadow: none;
		padding-left: 10px;
		height: 40px;
		min-height: 40px;
		background-color: transparent;

		&::-webkit-input-placeholder {
			font-weight: 400;
			color: #adadad;
			font-size: 13px;
		}
		&::-moz-placeholder {
			font-weight: 400;
			color: #adadad;
			font-size: 13px;
		}
		&::-ms-input-placeholder {
			font-weight: 400;
			color: #adadad;
			font-size: 13px;
		}
	}

	.mx-table-date .today{
		color: #FF93AD;
	}

	.mx-input:hover, .mx-input:focus{
		border-color: #FF93AD;
	}

	.mx-datepicker-header{
		background-color: #FF93AD;

		.mx-btn{
			color: #FF93AD;
		}
	}

	.vue-js-switch{
		margin-bottom: 0px !important;
		height: 32px !important;
		display: flex !important;
		align-items: center !important;
		width: auto !important;
	}

	.horas-minutos-switch{
		.vue-js-switch{
			margin-bottom: 0px !important;
			height: 14px !important;
			display: flex !important;
			align-items: center !important;
			width: auto !important;
			
			.v-switch-label{
				font-weight: 400 !important;
				line-height: 1em !important;
			}
		}
	}
</style>

<style lang="scss" scoped>
	#informacion-personal-page{
		width: 100%;
		@include flex(column, flex-start, flex-start);

		.info-personal-header{
			width: 100%;
			@include flex(column, flex-start, flex-start);
			margin-bottom: 40px;

			.breadcrumb {
				@include flex(row, flex-start, center);

				.breadcrumb-item {
					font-size: 12px;
					font-weight: var(--fw-600);
					letter-spacing: 0.3px;
					font-family: var(--font-sora);
					color: var(--color-darker);
					text-transform: capitalize;
					padding: 0px 5px;

					&:first-child{
						padding: 0px 5px 0px 0px;
					}
				}
			}

			h1{
				margin: 0;
				margin-top: 12px;
				font-family: var(--font-sora);
				font-size: 30px;
				line-height: 1em;
			}
		}

		.info-personal-content{
			width: 100%;
			@include flex(column, flex-start, flex-start);

			.info-personal-item{
				width: 100%;
				@include flex(column, flex-start, flex-start);
				padding: 26px 0px;
				border-bottom: 1px solid rgb(235, 235, 235);

				&:last-child{
					border-bottom: none;
				}

				.item-top{
					width: 100%;
					@include flex(row, space-between, flex-start);

					.label{
						font-size: 13px;
						font-weight: var(--fw-400);
						line-height: 1em;
						margin-bottom: 8px;
					}

					.item-right{
						font-size: 14px;
						@include flex(row, flex-end, center);
						text-decoration: underline;
						cursor: pointer;
						@include transition(all .2s);

						&:hover{
							opacity: 0.9;
						}
					}
				}

				.item-main{
					width: 100%;
					@include flex(column, flex-start, flex-start);

					.value{
						font-size: 15px;
						font-weight: var(--fw-600);
						line-height: 1em;
					}

					.editable-group{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.item-main-row{
							width: 100%;
							@include flex(row, space-between, center);

							.input-group{
								width: calc(50% - 10px);
								margin: 8px 0px 4px 0px;
								position: relative;
								@include flex(column, flex-start, flex-start);

								label {
									font-size: 13px;
									font-weight: var(--fw-600);
									margin-top: 0px;
									margin-bottom: 5px;
									line-height: 1em;
								}

								input {
									-webkit-appearance: none;
									appearance: none;
									border: none;
									width: 100%;
									padding: 0px 36px 0px 14px;
									font-size: 14px;
									font-weight: var(--fw-400);
									line-height: 1.4em;
									width: 100%;
									border-radius: 8px;
									height: 44px;
									outline: none;
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
									// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

									&::placeholder {
										color: #9aa5b5;
										opacity: 1;
									}

									&:-ms-input-placeholder {
										color: #9aa5b5;
									}

									&::-ms-input-placeholder {
										color: #9aa5b5;
									}

									&:focus-within {
										@include transition(all 0.2s);
										box-shadow: #222 0px 0px 0px 2px inset;

										&.form-input--error {
											box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
										}
									}

									&.form-input--error {
										box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
									}
								}

								input:-webkit-autofill,
								input:-webkit-autofill:hover,
								input:-webkit-autofill:focus,
								textarea:-webkit-autofill,
								textarea:-webkit-autofill:hover,
								textarea:-webkit-autofill:focus,
								select:-webkit-autofill,
								select:-webkit-autofill:hover,
								select:-webkit-autofill:focus {
									border: none;
									-webkit-text-fill-color: var(--color-darker);
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
										0 0 0px 1000px var(--color-white) inset;
									-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
										0 0 0px 1000px var(--color-white) inset;

									&:focus-within {
										box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset,
											0 0 0px 1000px var(--color-white) inset;
									}
								}
							}
						}

						button{
							@include flex(row, center, center);
							background-color: #222222;
							border: 1px solid #222222;
							border-radius: 8px;
							outline: none;
							padding: 12px 20px;
							color: var(--color-white);
							font-size: 13px;
							font-weight: var(--fw-600);
							font-family: var(--font-sora);
							line-height: 1.2em;
							letter-spacing: 0.6px;
							margin: 8px 0px 0px 0px;
							@include transition(all 0.2s);
							cursor: pointer;

							&:hover {
								// background-color: var(--color-black);
								background-color: var(--color-primary);
								border: 1px solid #222222;
								color: #222222;
								transform: translate(-0.25rem, -0.25rem);
								box-shadow: 0.25rem 0.25rem 0 #222222;
							}

							&:disabled {
								background-color: #e8e9eb;
								color: var(--color-darker);
								border-color: #e8e9eb;
								cursor: not-allowed;

								&:hover {
									background-color: #e8e9eb;
									border: 1px solid #e8e9eb;
									color: var(--color-darker);
									transform: none;
									box-shadow: none;
								}
							}

							.pagando-loader{
								margin-left: 10px;
								margin-bottom: -3px;
							}
						}
					}

					
				}
			}
		}
	}

	@media screen and (max-width: 600px){
		#informacion-personal-page{
			.info-personal-header{
				margin-bottom: 20px;

				.breadcrumb{
					.breadcrumb-item{
						font-size: 11px;
					}
				}

				h1{
					font-size: 22px;
				}
			}

			.info-personal-content{
				.info-personal-item{
					padding: 18px 0px;

					.item-top{
						.label{
							font-size: 12px;
						}

						.item-right{
							font-size: 13px;
						}
					}

					.item-main{
						.value{
							font-size: 14px;
						}
					}
				}
			}
		}
	}
</style>